import React, { useMemo } from "react";
import objectPath from "object-path";
// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";
// Import Layout components
import { Header } from "./header/Header";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Aside } from "./aside/Aside";
// import {Footer} from "./footer/Footer";
import { LayoutInit } from "./LayoutInit";
import { SubHeader } from "./subheader/SubHeader";
import { QuickPanel } from "./extras/offcanvas/QuickPanel";
import { QuickUser } from "./extras/offcanvas/QuickUser";
import { ScrollTop } from "./extras/ScrollTop";
import { StickyToolbar } from "./extras/StickyToolbar";
import {
  Snackbar,
  Button,
  IconButton,
  Slide,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Box,
} from "@material-ui/core";
import { ButtonBox } from "../../../app/components/ui";
import CloseIcon from "@material-ui/icons/Close";
import { WSnackbarProvider } from "../_core/WSnackbar";

export function Layout({ children }) {
  const uiService = useHtmlClassService();
  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended"),
    };
  }, [uiService]);
  // 新增 -- 暫時控制 Notification 用
  const [showGlobalNotify, setGlobalNotify] = React.useState(false);
  const [showNotify, setNotify] = React.useState(false);
  const [showDialog, setDialog] = React.useState(false);
  const closeGlobalNotify = () => {
    setGlobalNotify(false);
  };
  const closeNotify = () => {
    setNotify(false);
  };
  const toggleModal = () => {
    setDialog(!showDialog);
  };
  // 新增 -- 暫時控制 Notification 用

  return layoutProps.selfLayout !== "blank" ? (
    <WSnackbarProvider>
      {/* 全局Notification開始 */}
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        style={{ top: 84 }}
        open={showGlobalNotify}
        TransitionComponent={Slide}
        message="告警資訊顯示在這邊"
        action={
          <React.Fragment>
            <IconButton
              size="small"
              aria-label="close"
              color="inherit"
              onClick={closeGlobalNotify}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </React.Fragment>
        }
      />
      {/* 一般Notification開始 */}
      <Snackbar
        open={showNotify}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        style={{ top: 84 }}
        onClose={closeNotify}
        TransitionComponent={Slide}
        autoHideDuration={6000}
        ContentProps={{
          "aria-describedby": "message-id",
        }}
        message={<span id="message-id">一般警示訊息</span>}
      />
      {/* 通用Dialog開始 */}
      <Dialog
        aria-labelledby="customized-dialog-title"
        open={showDialog}
        maxWidth="xs"
        fullWidth
        PaperProps={{ p: 3 }}
      >
        <DialogTitle id="customized-dialog-title">
          <Box textAlign="center">警示標題</Box>
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            <Box textAlign="center">這邊是警示內容</Box>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <ButtonBox textAlign="center" width="100%">
            <Button variant="outlined" size="large" onClick={toggleModal}>
              關閉
            </Button>
            <Button
              variant="contained"
              size="large"
              color="primary"
              disableElevation
              onClick={toggleModal}
            >
              確認
            </Button>
          </ButtonBox>
        </DialogActions>
      </Dialog>
      {/*begin::Main*/}
      <HeaderMobile />
      <div className="d-flex flex-column flex-root bg-white">
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          {layoutProps.asideDisplay && <Aside />}
          {/*begin::Wrapper*/}
          <div
            className="d-flex flex-column flex-row-fluid wrapper"
            id="kt_wrapper"
          >
            <Header />
            {/*begin::Content*/}
            <div
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
            >
              {layoutProps.subheaderDisplay && <SubHeader />}
              {/*begin::Entry*/}
              {!layoutProps.contentExtended && (
                <div className="d-flex flex-column-fluid">
                  {/*begin::Container*/}
                  <div className={layoutProps.contentContainerClasses}>
                    {children}
                  </div>
                  {/*end::Container*/}
                </div>
              )}

              {layoutProps.contentExtended && { children }}
              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            {/*<Footer/>*/}
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}
      </div>
      <QuickUser />
      <QuickPanel />
      <ScrollTop />
      <StickyToolbar />
      {/*end::Main*/}
      <LayoutInit />
    </WSnackbarProvider>
  ) : (
    // BLANK LAYOUT
    <WSnackbarProvider>
      <div className="d-flex flex-column flex-root">{children}</div>
    </WSnackbarProvider>
  );
}
